module.exports = {
    generic: {
        spaces: 'bsgesales',
        apiEndpoint: 'https://app.bsge.co.uk'
    },
    meta: {
        title: 'Business Switch Gas & Electric'
    },
    appearance: {
        logo: {
            light: 'https://bsgesales.ams3.digitaloceanspaces.com/logo.svg',
            dark: 'https://bsgesales.ams3.digitaloceanspaces.com/logo.svg',
            mobile: 'https://bsgesales.ams3.digitaloceanspaces.com/logo.svg',
            email: 'https://i.imgur.com/3GiQlGz.png'
        }
    },
    email: {
        noreply: 'noreply@bsge.co.uk',
        pricing: {
            email: 'pricing@bsge.co.uk',
            subject: 'BSGE Pricing'
        },
        callUploader: {
            email: 'lewis.francis@bsge.co.uk',
            subject: 'Call Uploader'
        }
    },
    cookies: {
        system: '_bsgeSession',
        esign: '_esignSession'
    },
    api: {
        system: 'https://api.bsge.co.uk/',
        esign: 'https://api.esign.gec.cloud/signatures/'
    }
}